import React from "react";
import InlineCancel from "../../../helpers/InlineCancel";
import useStyles from "./CancelButton.styles";

export default function CancelButton({ pedido, setState }) {
  const classes = useStyles();

  return (
    <span className={classes.cancel}>
      <InlineCancel pedido={pedido} setState={setState} />
    </span>
  );
}
